import { render, staticRenderFns } from "./HeaderCrud.vue?vue&type=template&id=e20cb10a"
import script from "./HeaderCrud.vue?vue&type=script&lang=js"
export * from "./HeaderCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports